import React from 'react'

export default function UserHero() {
  return (
    <div className="forget-pass-banner">

      {
        localStorage.getItem("login") && localStorage.getItem("role")==="@A*_s&_k!=!@h!-%"?
        <img src="/images/payment/admin_.png" loading="lazy" alt="admin-profile" />
        :
        <img src="/images/payment/My-Profile_.png" loading="lazy" alt="my-profile" />



      }
        </div>
  )
}
